import { createFileRoute } from '@tanstack/react-router';
import SubscriptionPriorityPage from '@/features/subscription/subscription-priority-page';
import { subscriptionPriorityParamsSchema } from '@/features/subscription/shared/subscription-priority.schema';

export const Route = createFileRoute('/users/$userId/subscription/order-priority')({
  params: {
    parse: (raw) => subscriptionPriorityParamsSchema.parse(raw),
    stringify: ({ userId }) => ({
      userId: String(userId),
    }),
  },
  loader: async ({ context, params }) => {
    void context;
    void params;
  },
  component: SubscriptionPriorityPage,
});
